module.exports = __webpack_public_path__ + "img/pallina_empty.010ce6f4.svg";